(() => {
  const DISCOUNT_2_RATE = 0.10;
  const DISCOUNT_3_RATE = 0.20;

  const parseMoney = (value) => {
    if (!value) return 0;
    const match = String(value).replace(/\u00A0/g, ' ').match(/-?\d[\d,]*(?:\.\d+)?/);
    if (!match) return 0;
    const amount = Number.parseFloat(match[0].replace(/,/g, ''));
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  };

  const formatMoney = (cents) => {
    const amount = Math.max(0, Math.round(Number(cents) || 0)) / 100;
    return `Rs.${amount.toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const removeGhostSections = (productRoot) => {
    ['.orv-feature-row', '.orv-product-benefits', '.orv-capability-grid'].forEach((selector) => {
      productRoot.querySelectorAll(selector).forEach((section) => {
        if (section.children.length === 0 && !section.textContent.trim()) section.remove();
      });
    });
  };

  const ensurePriceParts = (row) => {
    let priceWrap = row.querySelector('.orv-bundle-price');
    let strong = priceWrap ? priceWrap.querySelector('strong') : row.querySelector(':scope > strong');
    if (!priceWrap) {
      priceWrap = document.createElement('span');
      priceWrap.className = 'orv-bundle-price';
      if (strong) {
        strong.parentNode.insertBefore(priceWrap, strong);
        priceWrap.appendChild(strong);
      } else {
        strong = document.createElement('strong');
        priceWrap.appendChild(strong);
        row.appendChild(priceWrap);
      }
    }
    let compare = priceWrap.querySelector('.orv-bundle-compare');
    if (!compare) {
      compare = document.createElement('del');
      compare.className = 'orv-bundle-compare';
      priceWrap.appendChild(compare);
    }
    let copy = row.querySelector('.orv-bundle-copy');
    if (!copy) {
      const textSpan = Array.from(row.children).find((el) => el.tagName === 'SPAN' && el !== priceWrap && !el.classList.contains('orv-bundle-radio'));
      if (textSpan) {
        textSpan.classList.add('orv-bundle-copy');
        copy = textSpan;
      }
    }
    let saving = copy ? copy.querySelector('.orv-bundle-saving') : null;
    if (!saving && copy) {
      saving = document.createElement('small');
      saving.className = 'orv-bundle-saving';
      copy.appendChild(saving);
    }
    return { strong, compare, saving };
  };

  const setRibbon = (row, text) => {
    if (!row) return;
    let badge = row.querySelector('.orv-bundle-corner-badge');
    if (!text) {
      badge?.remove();
      row.classList.remove('orv-bundle-has-ribbon');
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'orv-bundle-corner-badge';
      row.appendChild(badge);
    }
    badge.textContent = text;
    badge.style.display = '';
    row.classList.add('orv-bundle-has-ribbon');
  };

  const getUnitPrice = (productRoot) => {
    const variantSelect = productRoot.querySelector('[data-orv-variant]');
    const selectedOption = variantSelect?.options?.[variantSelect.selectedIndex];
    let cents = parseMoney(selectedOption?.dataset?.price);
    if (!cents) cents = parseMoney(productRoot.querySelector('[data-orv-price]')?.textContent);
    return cents;
  };

  const discountRateForQuantity = (qty) => qty >= 3 ? DISCOUNT_3_RATE : qty === 2 ? DISCOUNT_2_RATE : 0;

  const priceBundleRow = (row, unitCents) => {
    if (!row || !unitCents) return;
    const qty = Math.max(1, Number(row.dataset.quantity || 1));
    const original = unitCents * qty;
    const discountRate = discountRateForQuantity(qty);
    const actualDiscount = Math.round(original * discountRate);
    const finalPrice = Math.max(0, original - actualDiscount);
    const parts = ensurePriceParts(row);
    if (parts.strong) parts.strong.textContent = formatMoney(finalPrice);
    if (actualDiscount > 0) {
      if (parts.compare) {
        parts.compare.textContent = formatMoney(original);
        parts.compare.hidden = false;
        parts.compare.style.display = '';
      }
      if (parts.saving) {
        parts.saving.textContent = `You save ${formatMoney(actualDiscount)}`;
        parts.saving.hidden = false;
        parts.saving.style.display = '';
      }
    } else {
      if (parts.compare) {
        parts.compare.textContent = '';
        parts.compare.hidden = true;
        parts.compare.style.display = 'none';
      }
      if (parts.saving) {
        parts.saving.textContent = '';
        parts.saving.hidden = true;
        parts.saving.style.display = 'none';
      }
    }
    row.dataset.bundleOriginalCents = String(original);
    row.dataset.bundleFinalCents = String(finalPrice);
    row.dataset.bundleDiscountCents = String(actualDiscount);
  };

  const syncBundleSelection = (productRoot, selectedRow) => {
    const rows = productRoot.querySelectorAll('[data-orv-bundle]');
    const formWrap = productRoot.querySelector('[data-orv-product-form]') || productRoot;
    const qtyInput = formWrap.querySelector('input[name="quantity"], [data-orv-qty]');
    const qty = Math.max(1, Number(selectedRow.dataset.quantity || 1));
    rows.forEach((row) => {
      const active = row === selectedRow;
      row.classList.toggle('is-active', active);
      row.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    if (qtyInput) {
      qtyInput.value = String(qty);
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    let bundleProperty = formWrap.querySelector('input[name="properties[Bundle offer]"]');
    if (!bundleProperty) {
      bundleProperty = document.createElement('input');
      bundleProperty.type = 'hidden';
      bundleProperty.name = 'properties[Bundle offer]';
      const form = formWrap.querySelector('form[action*="/cart/add"]') || formWrap.closest('form[action*="/cart/add"]');
      if (form) form.appendChild(bundleProperty);
    }
    if (bundleProperty) {
      const discountCents = Number(selectedRow.dataset.bundleDiscountCents || 0);
      bundleProperty.value = discountCents > 0 ? `${qty} pieces - ${formatMoney(discountCents)} bundle discount` : `${qty} piece`;
    }
  };

  const bindBundleRows = (productRoot) => {
    productRoot.querySelectorAll('[data-orv-bundle]').forEach((row) => {
      if (row.dataset.orvGlobalBundleBound === 'true') return;
      row.dataset.orvGlobalBundleBound = 'true';
      row.setAttribute('role', 'radio');
      row.setAttribute('tabindex', '0');
      const choose = () => syncBundleSelection(productRoot, row);
      row.addEventListener('click', choose);
      row.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose();
        }
      });
    });
  };

  const applyAvatars = (productRoot, config) => {
    const avatarsWrap = productRoot.querySelector('.orv-product-social-proof__avatars');
    if (!avatarsWrap || !config) return;
    const urls = [1, 2, 3, 4, 5]
      .map((number) => config.getAttribute(`data-avatar-${number}`) || config.getAttribute(`data-avatar${number}`) || '')
      .filter(Boolean);
    if (!urls.length) return;
    avatarsWrap.innerHTML = '';
    urls.forEach((url) => {
      const image = document.createElement('img');
      image.src = url;
      image.width = 60;
      image.height = 60;
      image.loading = 'lazy';
      image.alt = '';
      image.setAttribute('aria-hidden', 'true');
      avatarsWrap.appendChild(image);
    });
  };

  const refreshBundlePrices = (productRoot) => {
    const unitCents = getUnitPrice(productRoot);
    if (!unitCents) return;
    productRoot.querySelectorAll('[data-orv-bundle]').forEach((row) => priceBundleRow(row, unitCents));
    const byQty = (qty) => productRoot.querySelector(`[data-orv-bundle][data-quantity="${qty}"]`);
    setRibbon(byQty(1), '');
    setRibbon(byQty(2), '🔥 Most Popular 🔥');
    setRibbon(byQty(3), '✨ Customer Favorite 👍');
    productRoot.querySelectorAll('[data-orv-bundle]').forEach((row) => {
      if (Number(row.dataset.quantity || 1) > 3) setRibbon(row, '');
    });
  };

  const normaliseTrustText = (index, value) => {
    const text = String(value || '').trim();
    if (index === 1 && (!text || text === 'Free Worldwide Shipping')) return 'Free Shipping on Every Order';
    if (index === 2 && (!text || text === '30-Day Money-Back Guarantee')) return '30-Day Hassle-Free Money-Back Guarantee';
    if (index === 3 && !text) return '24/7 Dedicated Customer Support';
    return text;
  };

  const getSelectedInventory = (productRoot) => {
    const inventoryScript = document.querySelector('[data-orv-variant-inventory]');
    if (!inventoryScript) return { managed: false, available: true, count: 0 };
    let inventory = [];
    try {
      inventory = JSON.parse(inventoryScript.textContent || '[]');
    } catch (_) {
      return { managed: false, available: true, count: 0 };
    }
    const variantSelect = productRoot.querySelector('[data-orv-variant]');
    const variantId = String(variantSelect?.value || productRoot.querySelector('input[name="id"]')?.value || '');
    const item = inventory.find((entry) => String(entry.id) === variantId) || inventory[0];
    if (!item) return { managed: false, available: true, count: 0 };
    return {
      managed: item.managed === true,
      available: item.available !== false,
      count: Math.max(0, Number(item.quantity || 0))
    };
  };

  const injectEnhancementStyles = () => {
    if (document.getElementById('orv-requested-product-extras-style')) return;
    const style = document.createElement('style');
    style.id = 'orv-requested-product-extras-style';
    style.textContent = `
      .orv-product .orv-review-assurances{display:grid;gap:6px;margin:10px 0 14px;padding:0 1px;color:#1F2937}
      .orv-product .orv-review-assurance{display:flex;align-items:center;gap:8px;min-height:22px;font-size:12px;line-height:1.35;font-weight:750}
      .orv-product .orv-review-assurance__icon{width:18px;flex:0 0 18px;display:inline-grid;place-items:center;font-size:13px;line-height:1}
      .orv-product .orv-product-purchase-extras .orv-purchase-trust{display:none!important}
      .orv-product .orv-delivery-urgency{margin:14px 0 6px;padding:15px 16px 14px;border:1px solid rgba(33,53,107,.16);border-radius:14px;background:#FDFBF6;color:#141A2E;font-family:inherit;box-shadow:0 8px 24px rgba(20,26,46,.055)}
      .orv-product .orv-delivery-urgency[hidden]{display:none!important}
      .orv-product .orv-estimated-delivery__header{display:flex;align-items:center;gap:9px;margin-bottom:14px;color:#141A2E;font-size:14px;line-height:1.25;font-weight:800}
      .orv-product .orv-estimated-delivery__truck{width:24px;height:24px;display:inline-grid;place-items:center;flex:0 0 24px;border:1px solid rgba(176,138,69,.42);border-radius:7px;background:#F1EADC;color:#21356B}
      .orv-product .orv-estimated-delivery__truck svg{width:15px;height:15px;display:block}
      .orv-product .orv-estimated-delivery__timeline{position:relative;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:0;padding-top:1px}
      .orv-product .orv-estimated-delivery__rail{position:absolute;z-index:0;top:15px;left:16.666%;right:16.666%;height:3px;border-radius:999px;background:rgba(176,138,69,.25)}
      .orv-product .orv-estimated-delivery__rail-active{position:absolute;z-index:1;top:15px;left:16.666%;width:16.666%;height:3px;border-radius:999px;background:#21356B}
      .orv-product .orv-estimated-delivery__step{position:relative;z-index:2;display:flex;min-width:0;flex-direction:column;align-items:center;text-align:center}
      .orv-product .orv-estimated-delivery__node{width:29px;height:29px;display:grid;place-items:center;border:2px solid rgba(33,53,107,.18);border-radius:50%;background:#FDFBF6;color:#B08A45;font-size:12px;line-height:1;font-weight:900;box-shadow:0 0 0 3px #FDFBF6}
      .orv-product .orv-estimated-delivery__step.is-current .orv-estimated-delivery__node{border-color:#21356B;background:#21356B;color:#fff}
      .orv-product .orv-estimated-delivery__label{margin-top:8px;color:#141A2E;font-size:11px;line-height:1.2;font-weight:800}
      .orv-product .orv-estimated-delivery__date{margin-top:3px;color:rgba(20,26,46,.62);font-size:10.5px;line-height:1.25;font-weight:600;white-space:nowrap}
      .orv-product .orv-estimated-delivery__step.is-current .orv-estimated-delivery__date{color:#21356B}
      @media(max-width:780px){
        .orv-product .orv-review-assurances{gap:5px;margin:9px 0 13px}
        .orv-product .orv-review-assurance{font-size:11.5px}
        .orv-product .orv-delivery-urgency{margin-top:11px;padding:13px 11px 12px;border-radius:12px}
        .orv-product .orv-estimated-delivery__header{margin-bottom:12px;font-size:13px}
        .orv-product .orv-estimated-delivery__truck{width:22px;height:22px;flex-basis:22px}
        .orv-product .orv-estimated-delivery__truck svg{width:14px;height:14px}
        .orv-product .orv-estimated-delivery__rail,.orv-product .orv-estimated-delivery__rail-active{top:14px}
        .orv-product .orv-estimated-delivery__node{width:27px;height:27px;font-size:11px}
        .orv-product .orv-estimated-delivery__label{margin-top:7px;font-size:10.5px}
        .orv-product .orv-estimated-delivery__date{font-size:9.5px}
      }
    `;
    document.head.appendChild(style);
  };

  const renderReviewAssurances = (productRoot, config) => {
    const rating = productRoot.querySelector('.orv-product-rating');
    if (!rating) return;
    productRoot.querySelector('.orv-review-assurances')?.remove();
    const oldTrust = productRoot.querySelector('.orv-product-purchase-extras .orv-purchase-trust');
    oldTrust?.remove();
    const oldExtras = productRoot.querySelector('.orv-product-purchase-extras');
    if (oldExtras && oldExtras.children.length === 0) oldExtras.remove();

    const items = [
      [config?.dataset?.trust1Icon || '🚚', normaliseTrustText(1, config?.dataset?.trust1Text)],
      [config?.dataset?.trust2Icon || '🔄', normaliseTrustText(2, config?.dataset?.trust2Text)],
      [config?.dataset?.trust3Icon || '💬', normaliseTrustText(3, config?.dataset?.trust3Text)]
    ];
    const block = document.createElement('div');
    block.className = 'orv-review-assurances';
    block.setAttribute('aria-label', 'Shopping benefits');
    items.forEach(([icon, text]) => {
      if (!text) return;
      const row = document.createElement('div');
      row.className = 'orv-review-assurance';
      const iconEl = document.createElement('span');
      iconEl.className = 'orv-review-assurance__icon';
      iconEl.setAttribute('aria-hidden', 'true');
      iconEl.textContent = icon;
      const textEl = document.createElement('strong');
      textEl.textContent = text;
      row.append(iconEl, textEl);
      block.appendChild(row);
    });
    rating.insertAdjacentElement('afterend', block);
  };

  const ordinal = (day) => {
    const mod100 = day % 100;
    if (mod100 >= 11 && mod100 <= 13) return `${day}th`;
    if (day % 10 === 1) return `${day}st`;
    if (day % 10 === 2) return `${day}nd`;
    if (day % 10 === 3) return `${day}rd`;
    return `${day}th`;
  };

  const formatDeliveryDate = (date) => {
    const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    return `${weekday}, ${ordinal(date.getDate())} ${month}`;
  };

  const formatEstimateDate = (date) => date.toLocaleDateString('en-PK', { day: 'numeric', month: 'short' });

  const renderDeliveryUrgency = (productRoot) => {
    const actions = productRoot.querySelector('.orv-form-actions');
    if (!actions) return;
    let block = productRoot.querySelector('.orv-delivery-urgency');
    if (!block) {
      block = document.createElement('div');
      block.className = 'orv-delivery-urgency';
    }
    if (block._orvDeliveryTimer) {
      clearInterval(block._orvDeliveryTimer);
      block._orvDeliveryTimer = null;
    }
    block.setAttribute('aria-live', 'polite');
    block.innerHTML = `
      <div class="orv-estimated-delivery__header">
        <span class="orv-estimated-delivery__truck" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 6h11v10H3z"></path><path d="M14 10h4l3 3v3h-7z"></path><circle cx="7" cy="18" r="2"></circle><circle cx="18" cy="18" r="2"></circle>
          </svg>
        </span>
        <strong>Estimated Delivery</strong>
      </div>
      <div class="orv-estimated-delivery__timeline" aria-label="Estimated order delivery timeline">
        <span class="orv-estimated-delivery__rail" aria-hidden="true"></span>
        <span class="orv-estimated-delivery__rail-active" aria-hidden="true"></span>
        <div class="orv-estimated-delivery__step is-current">
          <span class="orv-estimated-delivery__node" aria-hidden="true">✓</span>
          <span class="orv-estimated-delivery__label">Ordered</span>
          <span class="orv-estimated-delivery__date" data-orv-estimate-ordered></span>
        </div>
        <div class="orv-estimated-delivery__step">
          <span class="orv-estimated-delivery__node" aria-hidden="true">▣</span>
          <span class="orv-estimated-delivery__label">Shipped</span>
          <span class="orv-estimated-delivery__date" data-orv-estimate-shipped></span>
        </div>
        <div class="orv-estimated-delivery__step">
          <span class="orv-estimated-delivery__node" aria-hidden="true">⌂</span>
          <span class="orv-estimated-delivery__label">Delivered</span>
          <span class="orv-estimated-delivery__date" data-orv-estimate-delivered></span>
        </div>
      </div>`;
    if (actions.nextElementSibling !== block) actions.insertAdjacentElement('afterend', block);

    const addButton = productRoot.querySelector('.orv-add');
    const isSoldOut = !!addButton && (addButton.disabled || /sold\s*out/i.test(addButton.textContent || ''));
    block.hidden = isSoldOut;
    if (isSoldOut) return;

    const ordered = new Date();
    const shipped = new Date(ordered);
    const deliveredStart = new Date(ordered);
    const deliveredEnd = new Date(ordered);
    shipped.setDate(shipped.getDate() + 1);
    deliveredStart.setDate(deliveredStart.getDate() + 3);
    deliveredEnd.setDate(deliveredEnd.getDate() + 4);

    const orderedEl = block.querySelector('[data-orv-estimate-ordered]');
    const shippedEl = block.querySelector('[data-orv-estimate-shipped]');
    const deliveredEl = block.querySelector('[data-orv-estimate-delivered]');
    if (orderedEl) orderedEl.textContent = formatEstimateDate(ordered);
    if (shippedEl) shippedEl.textContent = formatEstimateDate(shipped);
    if (deliveredEl) deliveredEl.textContent = `${formatEstimateDate(deliveredStart)} – ${formatEstimateDate(deliveredEnd)}`;
  };

  const bindVariantRefresh = (productRoot) => {
    const variantSelect = productRoot.querySelector('[data-orv-variant]');
    if (!variantSelect || variantSelect.dataset.orvGlobalPriceBound === 'true') return;
    variantSelect.dataset.orvGlobalPriceBound = 'true';
    variantSelect.addEventListener('change', () => {
      requestAnimationFrame(() => {
        refreshBundlePrices(productRoot);
        const active = productRoot.querySelector('[data-orv-bundle].is-active');
        if (active) syncBundleSelection(productRoot, active);
        renderDeliveryUrgency(productRoot);
      });
    });
  };

  const applyProductSystem = () => {
    const productRoot = document.querySelector('.orv-product');
    const config = document.querySelector('.orv-product-fixes-config');
    if (!productRoot) return;
    injectEnhancementStyles();
    removeGhostSections(productRoot);
    applyAvatars(productRoot, config);
    refreshBundlePrices(productRoot);
    bindBundleRows(productRoot);
    renderReviewAssurances(productRoot, config);
    renderDeliveryUrgency(productRoot);
    bindVariantRefresh(productRoot);
    const selected = productRoot.querySelector('[data-orv-bundle].is-active') || productRoot.querySelector('[data-orv-bundle][data-quantity="1"]');
    if (selected) syncBundleSelection(productRoot, selected);
  };

  const run = () => requestAnimationFrame(() => requestAnimationFrame(applyProductSystem));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', run);
})();